/**
 * 🎭 Données mockées pour le développement
 *
 * Contient toutes les réponses mockées pour l'API
 */
export const MOCK_DATA = {
  // Auth
  auth: {
    me: {
      user: {
        _id: 'mock-user-id',
        id: 1,
        email: 'demo@predivent.com',
        businessName: 'Les Crêpes de Marie',
        firstName: 'Marie',
        lastName: 'Durand',
        name: 'Marie Durand',
        onboardingCompleted: true,
        merchantType: 'itinerant',
        activityType: 'food_truck_resto',
        services: ['delivery', 'catering'],
        affluence: 'medium',
        locationCity: 'Toulouse',
        location: {
          lat: 43.6007,
          lng: 1.4335,
          address: '15 rue du Taur',
          city: 'Toulouse',
          actionRadius: 15,
        },
      },
      subscription: {
        plan: 'pro',
        status: 'active',
        currentPeriodEnd: new Date(
          Date.now() + 30 * 24 * 60 * 60 * 1000,
        ).toISOString(),
      },
    },
    login: {
      user: {
        _id: 'mock-user-id',
        id: 1,
        email: 'demo@predivent.com',
        businessName: 'Les Crêpes de Marie',
        firstName: 'Marie',
        lastName: 'Durand',
        name: 'Marie Durand',
        onboardingCompleted: true,
        merchantType: 'itinerant',
        activityType: 'food_truck_resto',
      },
      token: (() => {
        const h = btoa(JSON.stringify({ alg: 'HS256', typ: 'JWT' }));
        const p = btoa(
          JSON.stringify({
            sub: 'mock-user-id',
            email: 'demo@predivent.com',
            iat: Math.floor(Date.now() / 1000),
            exp: Math.floor(Date.now() / 1000) + 30 * 24 * 60 * 60,
          }),
        );
        return `${h}.${p}.${btoa('mock-signature')}`;
      })(),
      message: 'Connexion réussie',
    },
    register: {
      user: {
        id: 2,
        email: 'newuser@example.com',
        name: 'New User',
        onboardingCompleted: false,
      },
      token: 'mock-jwt-token-67890',
      message: 'Inscription réussie',
    },
    verifyEmail: {
      success: true,
      message: 'Email vérifié avec succès',
    },
  },

  // Dashboard
  dashboard: {
    kpis: {
      revenue: {
        current: 15420,
        previous: 14200,
        percentageChange: 8.6,
        trend: 'up',
      },
      orders: {
        current: 156,
        previous: 142,
        percentageChange: 9.9,
        trend: 'up',
      },
      customers: {
        current: 89,
        previous: 85,
        percentageChange: 4.7,
        trend: 'up',
      },
      avgBasket: {
        current: 98.85,
        previous: 100.0,
        percentageChange: -1.15,
        trend: 'down',
      },
    },
    pendingActions: [
      {
        id: 1,
        type: 'stock',
        priority: 'high',
        title: 'Stock faible - Pain aux raisins',
        description: 'Il reste 3 unités',
        createdAt: new Date().toISOString(),
      },
      {
        id: 2,
        type: 'event',
        priority: 'medium',
        title: 'Marché de dimanche',
        description: 'Préparation recommandée',
        createdAt: new Date().toISOString(),
      },
    ],
    predictions: {
      today: {
        expectedRevenue: 850,
        expectedOrders: 42,
        confidence: 0.85,
        peakHours: ['12:00', '18:00'],
      },
      tomorrow: {
        expectedRevenue: 920,
        expectedOrders: 45,
        confidence: 0.82,
      },
    },
    weeklyTrends: {
      revenue: [1200, 1350, 1100, 1450, 1600, 1800, 1500],
      orders: [58, 62, 54, 68, 72, 85, 70],
      labels: ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'],
    },
    itinerant: {
      kpis: {
        avgRevenuePerEvent: 847,
        avgRevenuePerEventTrend: 12,
        eventsThisMonth: 6,
        eventsThisMonthDiff: 2,
        aiPrecision: 83,
        aiPrecisionTrend: 5,
        topProduct: 'Crêpe Suzette',
        topProductSales: 342,
        totalSavings: 245,
        totalSavingsTrend: 18,
      },
      eventsByStatus: {
        planned: [
          {
            id: 'evt-plan-1',
            userId: 'mock-user-id',
            name: 'Marché Arnaud Bernard',
            lat: 43.61,
            lng: 1.441,
            eventDate: (() => {
              const d = new Date();
              d.setDate(d.getDate() + 2);
              return d.toISOString();
            })(),
            startTime: '08:00',
            endTime: '14:00',
            duration: 6,
            location: 'Place Arnaud Bernard, Toulouse',
            eventType: 'market',
            expectedAttendance: 'medium',
            weatherCondition: 'sunny',
            temperature: 14,
            notes: '',
            status: 'planned',
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
          },
          {
            id: 'evt-plan-2',
            userId: 'mock-user-id',
            name: 'Fête privée Blagnac',
            lat: 43.6326,
            lng: 1.3938,
            eventDate: (() => {
              const d = new Date();
              d.setDate(d.getDate() + 3);
              return d.toISOString();
            })(),
            startTime: '18:00',
            endTime: '23:00',
            duration: 5,
            location: 'Blagnac',
            eventType: 'private',
            expectedAttendance: 'low',
            weatherCondition: 'sunny',
            temperature: 13,
            notes: '~100 personnes',
            status: 'planned',
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
          },
          {
            id: 'evt-plan-3',
            userId: 'mock-user-id',
            name: 'Festival Colomiers',
            lat: 43.611,
            lng: 1.337,
            eventDate: (() => {
              const d = new Date();
              d.setDate(d.getDate() + 4);
              return d.toISOString();
            })(),
            startTime: '14:00',
            endTime: '23:00',
            duration: 9,
            location: 'Centre-ville, Colomiers',
            eventType: 'festival',
            expectedAttendance: 'high',
            weatherCondition: 'cloudy',
            temperature: 12,
            notes: '',
            status: 'planned',
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
          },
          {
            id: 'evt-plan-4',
            userId: 'mock-user-id',
            name: 'Marché de Muret',
            lat: 43.461,
            lng: 1.326,
            eventDate: (() => {
              const d = new Date();
              d.setDate(d.getDate() + 5);
              return d.toISOString();
            })(),
            startTime: '07:00',
            endTime: '13:00',
            duration: 6,
            location: 'Place de la Halle, Muret',
            eventType: 'market',
            expectedAttendance: 'medium',
            weatherCondition: 'sunny',
            temperature: 11,
            notes: '',
            status: 'planned',
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
          },
          {
            id: 'evt-plan-5',
            userId: 'mock-user-id',
            name: 'Festival Albi',
            lat: 43.9277,
            lng: 2.1481,
            eventDate: (() => {
              const d = new Date();
              d.setDate(d.getDate() + 6);
              return d.toISOString();
            })(),
            startTime: '10:00',
            endTime: '22:00',
            duration: 12,
            location: 'Place du Vigan, Albi',
            eventType: 'festival',
            expectedAttendance: 'high',
            weatherCondition: 'sunny',
            temperature: 15,
            notes: 'Gros événement régional',
            status: 'planned',
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
          },
        ],
        active: [],
        completed: [
          {
            id: 'evt-comp-1',
            userId: 'mock-user-id',
            name: 'Marché de Noël Capitole',
            lat: 43.6045,
            lng: 1.444,
            eventDate: '2025-12-24T00:00:00.000Z',
            startTime: '09:00',
            endTime: '18:00',
            duration: 9,
            location: 'Place du Capitole, Toulouse',
            eventType: 'market',
            expectedAttendance: 'high',
            weatherCondition: 'sunny',
            temperature: 8,
            notes: '',
            status: 'completed',
            createdAt: '2025-12-22T00:00:00.000Z',
            updatedAt: '2025-12-24T18:00:00.000Z',
          },
          {
            id: 'evt-comp-2',
            userId: 'mock-user-id',
            name: 'Festival Ramonville',
            lat: 43.5497,
            lng: 1.4747,
            eventDate: '2025-12-30T00:00:00.000Z',
            startTime: '14:00',
            endTime: '23:00',
            duration: 9,
            location: 'Ramonville-Saint-Agne',
            eventType: 'festival',
            expectedAttendance: 'high',
            weatherCondition: 'cloudy',
            temperature: 11,
            notes: '',
            status: 'completed',
            createdAt: '2025-12-28T00:00:00.000Z',
            updatedAt: '2025-12-30T23:00:00.000Z',
          },
        ],
        analyzed: [
          {
            id: 'evt-ana-1',
            userId: 'mock-user-id',
            name: 'Foire de Muret',
            lat: 43.461,
            lng: 1.326,
            eventDate: '2025-10-15T00:00:00.000Z',
            startTime: '10:00',
            endTime: '19:00',
            duration: 9,
            location: 'Place de la Halle, Muret',
            eventType: 'market',
            expectedAttendance: 'medium',
            weatherCondition: 'sunny',
            temperature: 22,
            notes: '',
            status: 'analyzed',
            createdAt: '2025-10-10T00:00:00.000Z',
            updatedAt: '2025-10-16T00:00:00.000Z',
          },
          {
            id: 'evt-ana-2',
            userId: 'mock-user-id',
            name: 'Festival Blues Cahors',
            lat: 44.449,
            lng: 1.437,
            eventDate: '2025-07-15T00:00:00.000Z',
            startTime: '10:00',
            endTime: '22:00',
            duration: 12,
            location: 'Centre-ville, Cahors',
            eventType: 'festival',
            expectedAttendance: 'high',
            weatherCondition: 'sunny',
            temperature: 28,
            notes: '',
            status: 'analyzed',
            createdAt: '2025-07-10T00:00:00.000Z',
            updatedAt: '2025-07-16T00:00:00.000Z',
          },
        ],
      },
      timeline: (() => {
        const days: any[] = [];
        const weatherOptions = [
          { icon: '☁️', temp: 11, condition: 'cloudy' },
          { icon: '🌤️', temp: 13, condition: 'partly_cloudy' },
          { icon: '☀️', temp: 15, condition: 'sunny' },
          { icon: '🌧️', temp: 12, condition: 'rain_light' },
          { icon: '☁️', temp: 10, condition: 'cloudy' },
          { icon: '🌤️', temp: 14, condition: 'partly_cloudy' },
          { icon: '☀️', temp: 13, condition: 'sunny' },
        ];
        const dayNames = ['DIM', 'LUN', 'MAR', 'MER', 'JEU', 'VEN', 'SAM'];
        for (let i = 0; i < 7; i++) {
          const d = new Date();
          d.setDate(d.getDate() + i);
          days.push({
            date: d.toISOString(),
            dayName: dayNames[d.getDay()],
            dayNumber: d.getDate(),
            isToday: i === 0,
            weather: weatherOptions[i],
            events:
              i === 2
                ? [
                    {
                      id: 'evt-plan-1',
                      name: 'Marché Arnaud Bernard',
                      eventType: 'market',
                      status: 'planned',
                    },
                  ]
                : i === 6
                  ? [
                      {
                        id: 'evt-plan-3',
                        name: 'Fête privée',
                        eventType: 'private',
                        status: 'planned',
                      },
                    ]
                  : [],
            opportunities:
              i === 3
                ? [
                    {
                      id: 'opp-1',
                      name: 'Marché Artisanal Capitole',
                      location: 'Place du Capitole',
                      distance: '~1 km',
                      score: 92,
                      date: (() => {
                        const dd = new Date();
                        dd.setDate(dd.getDate() + 3);
                        return dd.toISOString();
                      })(),
                      timeRange: '8h-18h',
                      expectedAttendance: 2000,
                      estimatedRevenue: { low: 650, high: 900 },
                      competition: '3 food trucks (aucun crêpes)',
                      eventType: 'market',
                    },
                  ]
                : [],
          });
        }
        return days;
      })(),
      weatherAlerts: [
        {
          id: 'wa-1',
          severity: 'warning',
          icon: '⚠️',
          title: 'Vent fort prévu',
          message: 'Vents 40-50 km/h prévus au Festival Colomiers',
          advice: 'Sécurisez votre stand et prévoyez des lests',
          eventName: 'Festival Colomiers',
          date: (() => {
            const d = new Date();
            d.setDate(d.getDate() + 2);
            return d.toISOString();
          })(),
        },
        {
          id: 'wa-2',
          severity: 'info',
          icon: '☀️',
          title: 'Beau temps confirmé',
          message: 'Conditions optimales pour la Fête privée',
          advice: 'Opportunité pour boissons fraîches (+25%)',
          eventName: 'Fête privée',
          date: (() => {
            const d = new Date();
            d.setDate(d.getDate() + 6);
            return d.toISOString();
          })(),
        },
      ],
      insights: [
        {
          id: 'ins-1',
          type: 'pattern',
          icon: '🎯',
          title: 'Festivals : +45% CA',
          message: 'Vos festivals génèrent +45% de CA vs marchés traditionnels',
          impact: '+380€/événement',
        },
        {
          id: 'ins-2',
          type: 'pattern',
          icon: '📈',
          title: 'Samedi : meilleur jour',
          message: 'Vous vendez +35% le samedi vs les autres jours',
          impact: '+280€/samedi',
        },
        {
          id: 'ins-3',
          type: 'warning',
          icon: '⚠️',
          title: 'Rupture fréquente',
          message:
            'Crêpe Nutella en rupture 3 fois en février — augmentez la base',
          impact: '-120€ manque à gagner',
        },
        {
          id: 'ins-4',
          type: 'opportunity',
          icon: '💡',
          title: 'Boissons par beau temps',
          message:
            'Vos ventes de boissons augmentent de +30% par temps ensoleillé',
          impact: '+85€/événement',
        },
      ],
      topEvents: [
        {
          id: 'evt-ana-1',
          name: 'Festival Été',
          revenue: 1240,
          accuracy: 94,
          eventType: 'festival',
        },
        {
          id: 'evt-ana-2',
          name: 'Marché Bio',
          revenue: 980,
          accuracy: 89,
          eventType: 'market',
        },
        {
          id: 'evt-ana-3',
          name: 'Fête Locale',
          revenue: 850,
          accuracy: 87,
          eventType: 'school',
        },
      ],
      opportunities: [
        {
          id: 'opp-1',
          name: 'Marché Artisanal Capitole',
          location: 'Place du Capitole, Toulouse',
          lat: 43.6045,
          lng: 1.444,
          distance: '~1 km',
          score: 92,
          date: (() => {
            const d = new Date();
            d.setDate(d.getDate() + 3);
            return d.toISOString();
          })(),
          timeRange: '8h-18h',
          expectedAttendance: 2500,
          estimatedRevenue: { low: 700, high: 1000 },
          competition: '3 food trucks (aucun crêpes → niche libre)',
          eventType: 'market',
        },
        {
          id: 'opp-2',
          name: 'Concert Place Wilson',
          location: 'Place Wilson, Toulouse',
          lat: 43.6085,
          lng: 1.451,
          distance: '~3 km',
          score: 78,
          date: (() => {
            const d = new Date();
            d.setDate(d.getDate() + 4);
            return d.toISOString();
          })(),
          timeRange: '16h-22h',
          expectedAttendance: 800,
          estimatedRevenue: { low: 350, high: 500 },
          competition: '2 stands boissons',
          eventType: 'festival',
        },
        {
          id: 'opp-3',
          name: 'Marché Balma-Gramont',
          location: 'Centre commercial Balma-Gramont',
          lat: 43.613,
          lng: 1.543,
          distance: '~12 km',
          score: 71,
          date: (() => {
            const d = new Date();
            d.setDate(d.getDate() + 5);
            return d.toISOString();
          })(),
          timeRange: '7h-14h',
          expectedAttendance: 1200,
          estimatedRevenue: { low: 450, high: 650 },
          competition: '1 boulanger, 1 traiteur',
          eventType: 'market',
        },
        {
          id: 'opp-4',
          name: 'Fête du Cassoulet Castelnaudary',
          location: 'Centre-ville, Castelnaudary',
          lat: 43.318,
          lng: 1.954,
          distance: '~55 km',
          score: 65,
          date: (() => {
            const d = new Date();
            d.setDate(d.getDate() + 10);
            return d.toISOString();
          })(),
          timeRange: '10h-20h',
          expectedAttendance: 5000,
          estimatedRevenue: { low: 800, high: 1200 },
          competition: '10 stands alimentaires',
          eventType: 'festival',
        },
        {
          id: 'opp-5',
          name: 'Grand Marché de Cahors',
          location: 'Place Chapou, Cahors',
          lat: 44.449,
          lng: 1.437,
          distance: '~95 km',
          score: 55,
          date: (() => {
            const d = new Date();
            d.setDate(d.getDate() + 14);
            return d.toISOString();
          })(),
          timeRange: '6h-13h',
          expectedAttendance: 3000,
          estimatedRevenue: { low: 600, high: 900 },
          competition: '5 stands crêpes/gaufres',
          eventType: 'market',
        },
      ],

      // ─── Phase 2: Recommandations transparentes ─────────────
      recommendations: {
        'evt-plan-1': {
          eventId: 'evt-plan-1',
          eventName: 'Marché Arnaud Bernard',
          products: [
            {
              productName: 'Crêpe Suzette',
              unit: 'unités',
              recommended: 120,
              rangeLow: 95,
              rangeHigh: 145,
              coefficients: {
                base: 60,
                eventType: 1.5,
                weather: 1.1,
                duration: 1.2,
              },
            },
            {
              productName: 'Crêpe Nutella',
              unit: 'unités',
              recommended: 150,
              rangeLow: 120,
              rangeHigh: 180,
              coefficients: {
                base: 80,
                eventType: 1.5,
                weather: 1.0,
                duration: 1.25,
              },
            },
            {
              productName: 'Galette complète',
              unit: 'unités',
              recommended: 80,
              rangeLow: 60,
              rangeHigh: 100,
              coefficients: {
                base: 45,
                eventType: 1.4,
                weather: 1.05,
                duration: 1.2,
              },
            },
            {
              productName: 'Boisson fraîche',
              unit: 'bouteilles',
              recommended: 200,
              rangeLow: 160,
              rangeHigh: 240,
              coefficients: {
                base: 90,
                eventType: 1.5,
                weather: 1.3,
                duration: 1.15,
              },
            },
            {
              productName: 'Café',
              unit: 'tasses',
              recommended: 60,
              rangeLow: 40,
              rangeHigh: 80,
              coefficients: {
                base: 40,
                eventType: 1.2,
                weather: 0.9,
                duration: 1.4,
              },
            },
          ],
        },
        'evt-plan-2': {
          eventId: 'evt-plan-2',
          eventName: 'Marché de Nice',
          products: [
            {
              productName: 'Crêpe Suzette',
              unit: 'unités',
              recommended: 70,
              rangeLow: 55,
              rangeHigh: 85,
              coefficients: {
                base: 60,
                eventType: 1.0,
                weather: 0.95,
                duration: 1.2,
              },
            },
            {
              productName: 'Crêpe Nutella',
              unit: 'unités',
              recommended: 85,
              rangeLow: 65,
              rangeHigh: 105,
              coefficients: {
                base: 80,
                eventType: 1.0,
                weather: 0.9,
                duration: 1.18,
              },
            },
            {
              productName: 'Galette complète',
              unit: 'unités',
              recommended: 50,
              rangeLow: 38,
              rangeHigh: 62,
              coefficients: {
                base: 45,
                eventType: 1.0,
                weather: 0.95,
                duration: 1.17,
              },
            },
          ],
        },
      },

      // ─── Phase 2: Historique précision IA ────────────────────
      precisionHistory: [
        {
          eventId: 'evt-old-1',
          eventName: 'Marché Mougins',
          date: '2025-03-10',
          precision: 62,
        },
        {
          eventId: 'evt-old-2',
          eventName: 'Festival Printemps',
          date: '2025-04-15',
          precision: 68,
        },
        {
          eventId: 'evt-old-3',
          eventName: 'Marché Bio',
          date: '2025-05-20',
          precision: 74,
        },
        {
          eventId: 'evt-old-4',
          eventName: 'Fête Village',
          date: '2025-06-08',
          precision: 79,
        },
        {
          eventId: 'evt-ana-1',
          eventName: 'Festival Été',
          date: '2025-07-15',
          precision: 83,
        },
        {
          eventId: 'evt-old-5',
          eventName: 'Marché Nocturne',
          date: '2025-08-22',
          precision: 81,
        },
        {
          eventId: 'evt-old-6',
          eventName: 'Fête Rentrée',
          date: '2025-09-14',
          precision: 85,
        },
        {
          eventId: 'evt-old-7',
          eventName: 'Marché Automne',
          date: '2025-10-05',
          precision: 87,
        },
        {
          eventId: 'evt-ana-2',
          eventName: 'Marché Bio',
          date: '2025-11-10',
          precision: 89,
        },
        {
          eventId: 'evt-comp-2',
          eventName: 'Festival Ramonville',
          date: '2025-12-30',
          precision: 83,
        },
      ],

      // ─── Phase 3: Checklists pré-événement ──────────────────
      checklists: {
        'evt-plan-1': {
          eventId: 'evt-plan-1',
          eventName: 'Marché Arnaud Bernard',
          items: [
            {
              id: 'ck-1',
              label: 'Crêpe Suzette — 120 unités',
              category: 'approvisionnement',
              completed: false,
              quantity: '120 unités',
            },
            {
              id: 'ck-2',
              label: 'Crêpe Nutella — 150 unités',
              category: 'approvisionnement',
              completed: false,
              quantity: '150 unités',
            },
            {
              id: 'ck-3',
              label: 'Galette complète — 80 unités',
              category: 'approvisionnement',
              completed: false,
              quantity: '80 unités',
            },
            {
              id: 'ck-4',
              label: 'Boisson fraîche — 200 bouteilles',
              category: 'approvisionnement',
              completed: false,
              quantity: '200 bouteilles',
            },
            {
              id: 'ck-5',
              label: 'Café — 60 tasses',
              category: 'approvisionnement',
              completed: false,
              quantity: '60 tasses',
            },
            {
              id: 'ck-6',
              label: 'Vérifier le véhicule et le plein',
              category: 'logistique',
              completed: false,
            },
            {
              id: 'ck-7',
              label: 'Charger le matériel de stand',
              category: 'logistique',
              completed: false,
            },
            {
              id: 'ck-8',
              label: 'Préparer la monnaie (150€)',
              category: 'logistique',
              completed: false,
            },
            {
              id: 'ck-9',
              label: 'Prévoir lests et fixations (vent fort prévu)',
              category: 'meteo',
              completed: false,
              contextual: true,
            },
            {
              id: 'ck-10',
              label: 'Sécuriser la bâche',
              category: 'meteo',
              completed: false,
              contextual: true,
            },
            {
              id: 'ck-11',
              label: 'Vérifier autorisation emplacement',
              category: 'administratif',
              completed: false,
            },
            {
              id: 'ck-12',
              label: 'Imprimer fiche sanitaire HACCP',
              category: 'administratif',
              completed: false,
            },
            {
              id: 'ck-13',
              label: 'Vérifier chaîne du froid (glacières)',
              category: 'conservation',
              completed: false,
            },
            {
              id: 'ck-14',
              label: 'Préparer conteneurs isothermes',
              category: 'conservation',
              completed: false,
            },
          ],
        },
        'evt-plan-2': {
          eventId: 'evt-plan-2',
          eventName: 'Marché de Nice',
          items: [
            {
              id: 'ck-20',
              label: 'Crêpe Suzette — 70 unités',
              category: 'approvisionnement',
              completed: false,
              quantity: '70 unités',
            },
            {
              id: 'ck-21',
              label: 'Crêpe Nutella — 85 unités',
              category: 'approvisionnement',
              completed: false,
              quantity: '85 unités',
            },
            {
              id: 'ck-22',
              label: 'Galette complète — 50 unités',
              category: 'approvisionnement',
              completed: false,
              quantity: '50 unités',
            },
            {
              id: 'ck-23',
              label: 'Vérifier le véhicule et le plein',
              category: 'logistique',
              completed: false,
            },
            {
              id: 'ck-24',
              label: 'Charger le matériel de stand',
              category: 'logistique',
              completed: false,
            },
            {
              id: 'ck-25',
              label: 'Préparer la monnaie (100€)',
              category: 'logistique',
              completed: false,
            },
            {
              id: 'ck-26',
              label: 'Prévoir parapluie (nuageux)',
              category: 'meteo',
              completed: false,
              contextual: true,
            },
            {
              id: 'ck-27',
              label: 'Vérifier autorisation emplacement',
              category: 'administratif',
              completed: false,
            },
            {
              id: 'ck-28',
              label: 'Vérifier chaîne du froid',
              category: 'conservation',
              completed: false,
            },
          ],
        },
      },

      // Legacy format (kept for backward compat)
      upcomingEvents: [
        {
          id: 1,
          name: 'Marché de Noël',
          location: 'Place de la République',
          startDate: '2026-12-20',
          endDate: '2026-12-24',
          status: 'planned',
          estimatedRevenue: 2500,
        },
        {
          id: 3,
          name: 'Marché du village',
          location: 'Centre ville',
          startDate: '2026-02-15',
          endDate: '2026-02-15',
          status: 'planned',
          estimatedRevenue: 800,
        },
      ],
      eventPerformance: [
        {
          type: 'Marché',
          count: 12,
          totalRevenue: 8500,
          avgRevenue: 708.33,
        },
        {
          type: 'Festival',
          count: 5,
          totalRevenue: 6200,
          avgRevenue: 1240,
        },
        {
          type: 'Fête locale',
          count: 8,
          totalRevenue: 4800,
          avgRevenue: 600,
        },
      ],
      locationStats: {
        topLocations: [
          {
            name: 'Place de la République',
            city: 'Paris',
            eventsCount: 8,
            totalRevenue: 12000,
            avgRevenue: 1500,
          },
          {
            name: 'Marché Saint-Antoine',
            city: 'Lyon',
            eventsCount: 6,
            totalRevenue: 8500,
            avgRevenue: 1417,
          },
        ],
      },
    },
  },

  // Events
  events: {
    list: [
      {
        id: 1,
        name: 'Marché de Noël',
        location: 'Place de la République',
        startDate: '2026-12-20',
        endDate: '2026-12-24',
        status: 'planned',
        estimatedRevenue: 2500,
      },
      {
        id: 2,
        name: 'Fête de la musique',
        location: 'Centre ville',
        startDate: '2026-06-21',
        endDate: '2026-06-21',
        status: 'completed',
        actualRevenue: 1850,
      },
    ],
    singleEvent: {
      id: 1,
      name: 'Marché de Noël',
      location: 'Place de la République',
      startDate: '2026-12-20',
      endDate: '2026-12-24',
      status: 'planned',
      estimatedRevenue: 2500,
      description: 'Grand marché de Noël annuel',
    },
    createEvent: {
      id: 3,
      name: 'Nouvel événement',
      status: 'draft',
      message: 'Événement créé avec succès',
    },
  },

  // Recommendations
  recommendations: {
    list: [
      {
        id: 1,
        type: 'product',
        title: 'Augmenter le stock de croissants',
        description: 'Basé sur les tendances des 30 derniers jours',
        priority: 'high',
        impact: '+15% de ventes potentielles',
      },
      {
        id: 2,
        type: 'event',
        title: 'Participer au marché du 1er mai',
        description: 'Forte affluence attendue',
        priority: 'medium',
        impact: '+2000€ de CA estimé',
      },
    ],
  },

  // Plans/Subscriptions
  plans: {
    list: [
      {
        id: 1,
        name: 'Starter',
        price: 29,
        interval: 'month',
        features: ['Dashboard basique', '10 événements/mois', 'Support email'],
      },
      {
        id: 2,
        name: 'Pro',
        price: 79,
        interval: 'month',
        features: [
          'Dashboard avancé',
          'Événements illimités',
          'Support prioritaire',
          'Analytics',
        ],
      },
    ],
  },
  subscription: {
    checkoutSession: {
      sessionId: 'mock-stripe-session-123',
      url: 'https://checkout.stripe.com/mock',
    },
  },

  // Products - 30 products for testing scrollbar
  products: {
    list: [
      {
        id: 1,
        name: 'Croissant',
        price: 1.2,
        stock: 50,
        category: 'Viennoiserie',
        icon: '🥐',
        purchasePrice: 0.5,
        sellPrice: 1.2,
        popularity: 9,
        isAISuggested: true,
      },
      {
        id: 2,
        name: 'Pain au chocolat',
        price: 1.4,
        stock: 35,
        category: 'Viennoiserie',
        icon: '🍫',
        purchasePrice: 0.6,
        sellPrice: 1.4,
        popularity: 8,
        isAISuggested: true,
      },
      {
        id: 3,
        name: 'Baguette',
        price: 1.1,
        stock: 100,
        category: 'Pain',
        icon: '🥖',
        purchasePrice: 0.4,
        sellPrice: 1.1,
        popularity: 10,
        isAISuggested: false,
      },
      {
        id: 4,
        name: 'Pain aux raisins',
        price: 1.5,
        stock: 25,
        category: 'Viennoiserie',
        icon: '🍇',
        purchasePrice: 0.7,
        sellPrice: 1.5,
        popularity: 7,
        isAISuggested: true,
      },
      {
        id: 5,
        name: 'Éclair au chocolat',
        price: 2.8,
        stock: 15,
        category: 'Pâtisserie',
        icon: '🍰',
        purchasePrice: 1.2,
        sellPrice: 2.8,
        popularity: 6,
        isAISuggested: false,
      },
      {
        id: 6,
        name: 'Tarte aux pommes',
        price: 8.0,
        stock: 5,
        category: 'Pâtisserie',
        icon: '🥧',
        purchasePrice: 3.5,
        sellPrice: 8.0,
        popularity: 5,
        isAISuggested: false,
      },
      {
        id: 7,
        name: 'Chausson aux pommes',
        price: 1.8,
        stock: 30,
        category: 'Viennoiserie',
        icon: '🥟',
        purchasePrice: 0.8,
        sellPrice: 1.8,
        popularity: 8,
        isAISuggested: true,
      },
      {
        id: 8,
        name: 'Brioche',
        price: 2.0,
        stock: 20,
        category: 'Viennoiserie',
        icon: '🍞',
        purchasePrice: 0.9,
        sellPrice: 2.0,
        popularity: 7,
        isAISuggested: true,
      },
      {
        id: 9,
        name: 'Mille-feuille',
        price: 3.5,
        stock: 10,
        category: 'Pâtisserie',
        icon: '🎂',
        purchasePrice: 1.5,
        sellPrice: 3.5,
        popularity: 6,
        isAISuggested: false,
      },
      {
        id: 10,
        name: 'Croissant amandes',
        price: 2.2,
        stock: 25,
        category: 'Viennoiserie',
        icon: '🥐',
        purchasePrice: 1.0,
        sellPrice: 2.2,
        popularity: 9,
        isAISuggested: true,
      },
      {
        id: 11,
        name: 'Palmier',
        price: 1.0,
        stock: 40,
        category: 'Viennoiserie',
        icon: '🌴',
        purchasePrice: 0.4,
        sellPrice: 1.0,
        popularity: 5,
        isAISuggested: false,
      },
      {
        id: 12,
        name: 'Chouquette',
        price: 0.3,
        stock: 100,
        category: 'Viennoiserie',
        icon: '🧁',
        purchasePrice: 0.1,
        sellPrice: 0.3,
        popularity: 4,
        isAISuggested: false,
      },
      {
        id: 13,
        name: 'Paris-Brest',
        price: 4.5,
        stock: 8,
        category: 'Pâtisserie',
        icon: '🍩',
        purchasePrice: 2.0,
        sellPrice: 4.5,
        popularity: 7,
        isAISuggested: true,
      },
      {
        id: 14,
        name: 'Opéra',
        price: 5.0,
        stock: 6,
        category: 'Pâtisserie',
        icon: '🎼',
        purchasePrice: 2.2,
        sellPrice: 5.0,
        popularity: 6,
        isAISuggested: false,
      },
      {
        id: 15,
        name: 'Tarte citron',
        price: 3.8,
        stock: 10,
        category: 'Pâtisserie',
        icon: '🍋',
        purchasePrice: 1.6,
        sellPrice: 3.8,
        popularity: 8,
        isAISuggested: true,
      },
      {
        id: 16,
        name: 'Flan pâtissier',
        price: 2.5,
        stock: 15,
        category: 'Pâtisserie',
        icon: '🍮',
        purchasePrice: 1.0,
        sellPrice: 2.5,
        popularity: 7,
        isAISuggested: true,
      },
      {
        id: 17,
        name: 'Pain de campagne',
        price: 2.8,
        stock: 30,
        category: 'Pain',
        icon: '🍞',
        purchasePrice: 1.2,
        sellPrice: 2.8,
        popularity: 6,
        isAISuggested: false,
      },
      {
        id: 18,
        name: 'Pain complet',
        price: 2.5,
        stock: 25,
        category: 'Pain',
        icon: '🌾',
        purchasePrice: 1.0,
        sellPrice: 2.5,
        popularity: 5,
        isAISuggested: false,
      },
      {
        id: 19,
        name: 'Café expresso',
        price: 1.5,
        stock: 200,
        category: 'Boissons',
        icon: '☕',
        purchasePrice: 0.3,
        sellPrice: 1.5,
        popularity: 10,
        isAISuggested: true,
      },
      {
        id: 20,
        name: 'Thé',
        price: 1.8,
        stock: 150,
        category: 'Boissons',
        icon: '🍵',
        purchasePrice: 0.4,
        sellPrice: 1.8,
        popularity: 6,
        isAISuggested: false,
      },
      {
        id: 21,
        name: "Jus d'orange",
        price: 2.5,
        stock: 50,
        category: 'Boissons',
        icon: '🍊',
        purchasePrice: 1.0,
        sellPrice: 2.5,
        popularity: 8,
        isAISuggested: true,
      },
      {
        id: 22,
        name: 'Sandwich jambon',
        price: 4.5,
        stock: 20,
        category: 'Sandwichs',
        icon: '🥪',
        purchasePrice: 2.0,
        sellPrice: 4.5,
        popularity: 9,
        isAISuggested: true,
      },
      {
        id: 23,
        name: 'Sandwich poulet',
        price: 5.0,
        stock: 18,
        category: 'Sandwichs',
        icon: '🐔',
        purchasePrice: 2.2,
        sellPrice: 5.0,
        popularity: 8,
        isAISuggested: true,
      },
      {
        id: 24,
        name: 'Quiche lorraine',
        price: 3.5,
        stock: 12,
        category: 'Salé',
        icon: '🥧',
        purchasePrice: 1.5,
        sellPrice: 3.5,
        popularity: 7,
        isAISuggested: true,
      },
      {
        id: 25,
        name: 'Croque-monsieur',
        price: 4.0,
        stock: 15,
        category: 'Salé',
        icon: '🧀',
        purchasePrice: 1.8,
        sellPrice: 4.0,
        popularity: 8,
        isAISuggested: true,
      },
      {
        id: 26,
        name: 'Salade Caesar',
        price: 6.5,
        stock: 10,
        category: 'Salades',
        icon: '🥗',
        purchasePrice: 2.8,
        sellPrice: 6.5,
        popularity: 6,
        isAISuggested: false,
      },
      {
        id: 27,
        name: 'Cookie chocolat',
        price: 1.5,
        stock: 60,
        category: 'Biscuits',
        icon: '🍪',
        purchasePrice: 0.5,
        sellPrice: 1.5,
        popularity: 9,
        isAISuggested: true,
      },
      {
        id: 28,
        name: 'Macaron',
        price: 2.0,
        stock: 40,
        category: 'Pâtisserie',
        icon: '🌈',
        purchasePrice: 0.8,
        sellPrice: 2.0,
        popularity: 7,
        isAISuggested: false,
      },
      {
        id: 29,
        name: 'Financier',
        price: 1.8,
        stock: 35,
        category: 'Pâtisserie',
        icon: '🟫',
        purchasePrice: 0.7,
        sellPrice: 1.8,
        popularity: 5,
        isAISuggested: false,
      },
      {
        id: 30,
        name: 'Madeleine',
        price: 1.2,
        stock: 50,
        category: 'Pâtisserie',
        icon: '🧈',
        purchasePrice: 0.4,
        sellPrice: 1.2,
        popularity: 6,
        isAISuggested: false,
      },
    ],
  },

  // Product Catalog
  productCatalog: {
    catalog: {
      success: true,
      data: [
        {
          id: '1',
          name: 'Croissant',
          description: 'Croissant au beurre frais',
          category: 'Viennoiserie',
          defaultPurchasePrice: 0.5,
          defaultSellPrice: 1.2,
          purchasePrice: 0.5,
          sellPrice: 1.2,
          quantity: 50,
          unit: 'pièce',
          sku: 'CROIS-001',
          productIcon: '🥐',
          popularity: 9,
          isRecommended: true,
          isAISuggested: true,
          isCustom: false,
          createdAt: new Date(),
          updatedAt: new Date(),
        },
        {
          id: '2',
          name: 'Pain au chocolat',
          description: 'Pain au chocolat traditionnel',
          category: 'Viennoiserie',
          defaultPurchasePrice: 0.6,
          defaultSellPrice: 1.4,
          purchasePrice: 0.6,
          sellPrice: 1.4,
          quantity: 35,
          unit: 'pièce',
          sku: 'PAINCHOC-001',
          productIcon: '🍫',
          popularity: 8,
          isRecommended: true,
          isAISuggested: true,
          isCustom: false,
          createdAt: new Date(),
          updatedAt: new Date(),
        },
        {
          id: '3',
          name: 'Baguette',
          description: 'Baguette traditionnelle française',
          category: 'Pain',
          defaultPurchasePrice: 0.4,
          defaultSellPrice: 1.1,
          purchasePrice: 0.4,
          sellPrice: 1.1,
          quantity: 100,
          unit: 'pièce',
          sku: 'BAG-001',
          productIcon: '🥖',
          popularity: 10,
          isRecommended: true,
          isAISuggested: false,
          isCustom: false,
          createdAt: new Date(),
          updatedAt: new Date(),
        },
        {
          id: '4',
          name: 'Pain aux raisins',
          description: 'Pain aux raisins fait maison',
          category: 'Viennoiserie',
          defaultPurchasePrice: 0.7,
          defaultSellPrice: 1.5,
          purchasePrice: 0.7,
          sellPrice: 1.5,
          quantity: 25,
          unit: 'pièce',
          sku: 'PAINRAIS-001',
          productIcon: '🍇',
          popularity: 7,
          isRecommended: true,
          isAISuggested: true,
          isCustom: false,
          createdAt: new Date(),
          updatedAt: new Date(),
        },
        {
          id: '5',
          name: 'Éclair au chocolat',
          description: 'Éclair garni de crème pâtissière au chocolat',
          category: 'Pâtisserie',
          defaultPurchasePrice: 1.2,
          defaultSellPrice: 2.8,
          purchasePrice: 1.2,
          sellPrice: 2.8,
          quantity: 15,
          unit: 'pièce',
          sku: 'ECLAIR-001',
          productIcon: '🍰',
          popularity: 6,
          isRecommended: false,
          isAISuggested: false,
          isCustom: false,
          createdAt: new Date(),
          updatedAt: new Date(),
        },
        {
          id: '6',
          name: 'Tarte aux pommes',
          description: 'Tarte aux pommes maison',
          category: 'Pâtisserie',
          defaultPurchasePrice: 3.5,
          defaultSellPrice: 8.0,
          purchasePrice: 3.5,
          sellPrice: 8.0,
          quantity: 5,
          unit: 'pièce',
          sku: 'TARTE-001',
          productIcon: '🥧',
          popularity: 5,
          isRecommended: false,
          isAISuggested: false,
          isCustom: true,
          createdAt: new Date(),
          updatedAt: new Date(),
        },
      ],
    },
    recommended: {
      success: true,
      data: [
        {
          id: '1',
          name: 'Croissant',
          description: 'Croissant au beurre frais',
          category: 'Viennoiserie',
          defaultPurchasePrice: 0.5,
          defaultSellPrice: 1.2,
          purchasePrice: 0.5,
          sellPrice: 1.2,
          quantity: 50,
          unit: 'pièce',
          sku: 'CROIS-001',
          productIcon: '🥐',
          popularity: 9,
          isRecommended: true,
          isAISuggested: true,
          isCustom: false,
          createdAt: new Date(),
          updatedAt: new Date(),
        },
        {
          id: '2',
          name: 'Pain au chocolat',
          description: 'Pain au chocolat traditionnel',
          category: 'Viennoiserie',
          defaultPurchasePrice: 0.6,
          defaultSellPrice: 1.4,
          purchasePrice: 0.6,
          sellPrice: 1.4,
          quantity: 35,
          unit: 'pièce',
          sku: 'PAINCHOC-001',
          productIcon: '🍫',
          popularity: 8,
          isRecommended: true,
          isAISuggested: true,
          isCustom: false,
          createdAt: new Date(),
          updatedAt: new Date(),
        },
        {
          id: '4',
          name: 'Pain aux raisins',
          description: 'Pain aux raisins fait maison',
          category: 'Viennoiserie',
          defaultPurchasePrice: 0.7,
          defaultSellPrice: 1.5,
          purchasePrice: 0.7,
          sellPrice: 1.5,
          quantity: 25,
          unit: 'pièce',
          sku: 'PAINRAIS-001',
          productIcon: '🍇',
          popularity: 7,
          isRecommended: true,
          isAISuggested: true,
          isCustom: false,
          createdAt: new Date(),
          updatedAt: new Date(),
        },
      ],
    },
  },

  // Merchant Types
  merchantTypes: {
    list: [
      {
        id: 1,
        name: 'Boulangerie',
        icon: '🥖',
        description: 'Commerce fixe de vente de pain et viennoiseries',
      },
      {
        id: 2,
        name: 'Food Truck',
        icon: '🚚',
        description: 'Commerce itinérant de restauration',
      },
      {
        id: 3,
        name: 'Marché',
        icon: '🛒',
        description: 'Stand de marché',
      },
    ],
  },

  // User
  user: {
    profile: {
      id: 1,
      email: 'test@example.com',
      name: 'John Doe',
      merchantType: 'fixed',
      onboardingCompleted: true,
      subscription: {
        plan: 'Pro',
        status: 'active',
        expiresAt: '2026-12-31',
      },
    },
  },

  // Locations
  locations: {
    list: [
      {
        id: 1,
        name: 'Place de la République',
        city: 'Paris',
        postalCode: '75011',
        coordinates: { lat: 48.8679, lng: 2.3634 },
      },
      {
        id: 2,
        name: 'Marché Saint-Antoine',
        city: 'Lyon',
        postalCode: '69003',
        coordinates: { lat: 45.7579, lng: 4.842 },
      },
    ],
  },

  // ═══ Daily Sales (Phase 4) ═══
  dailySales: {
    // Événements en attente de saisie de ventes
    pendingEvents: [
      {
        _id: 'evt-comp-1',
        name: 'Marché de Noël Capitole',
        eventDate: '2025-12-24T00:00:00.000Z',
        eventType: 'market',
        location: 'Place du Capitole, Toulouse',
        status: 'pending',
      },
      {
        _id: 'evt-comp-2',
        name: 'Festival Ramonville',
        eventDate: '2025-12-30T00:00:00.000Z',
        eventType: 'festival',
        location: 'Ramonville-Saint-Agne',
        status: 'pending',
      },
    ],

    // Réponse standard pour une création / mise à jour
    createResponse: {
      _id: 'ds-mock-001',
      userId: 'mock-user-id',
      merchantType: 'itinerant',
      source: 'manual',
      isValidated: false,
      usedForLearning: false,
      summary: {
        totalRevenue: 847,
        totalQuantitySold: 198,
        totalQuantityPrepared: 220,
        totalQuantityWasted: 22,
        averageWasteRate: 10,
        averageSellThroughRate: 90,
        averageAccuracyVsRecommendation: 86.5,
        productCount: 5,
      },
      createdAt: new Date().toISOString(),
    },

    // Réponse de validation avec apprentissage
    validateResponse: {
      success: true,
      dailySales: {
        _id: 'ds-mock-001',
        isValidated: true,
        validatedAt: new Date().toISOString(),
        usedForLearning: true,
        usedForLearningAt: new Date().toISOString(),
        summary: {
          totalRevenue: 847,
          totalQuantitySold: 198,
          totalQuantityPrepared: 220,
          totalQuantityWasted: 22,
          averageWasteRate: 10,
          averageSellThroughRate: 90,
          averageAccuracyVsRecommendation: 86.5,
          productCount: 5,
        },
      },
      learningUpdated: true,
    },

    // Brouillon sauvegardé
    draftResponse: {
      _id: 'ds-draft-001',
      userId: 'mock-user-id',
      merchantType: 'itinerant',
      source: 'manual',
      isDraft: true,
      isValidated: false,
      usedForLearning: false,
      summary: {
        totalRevenue: 0,
        totalQuantitySold: 0,
        totalQuantityPrepared: 0,
        totalQuantityWasted: 0,
        averageWasteRate: 0,
        averageSellThroughRate: 0,
        averageAccuracyVsRecommendation: 0,
        productCount: 0,
      },
      createdAt: new Date().toISOString(),
    },
  },

  // ═══ Predictions (Phase 4) ═══
  eventPredictions: {
    // Prédictions par événement
    'evt-comp-1': {
      _id: 'pred-evt-comp-1',
      userId: 'mock-user-id',
      date: '2025-12-24',
      eventId: 'evt-comp-1',
      eventName: 'Marché de Noël Capitole',
      predictedProducts: [
        {
          productId: '1',
          productName: 'Croissant',
          predictedQuantity: 45,
          confidenceLevel: 0.88,
          basedOnDays: 12,
          minQuantity: 38,
          maxQuantity: 52,
        },
        {
          productId: '2',
          productName: 'Pain au chocolat',
          predictedQuantity: 35,
          confidenceLevel: 0.85,
          basedOnDays: 12,
          minQuantity: 28,
          maxQuantity: 42,
        },
        {
          productId: '3',
          productName: 'Baguette',
          predictedQuantity: 60,
          confidenceLevel: 0.82,
          basedOnDays: 10,
          minQuantity: 50,
          maxQuantity: 70,
        },
        {
          productId: '4',
          productName: 'Pain aux raisins',
          predictedQuantity: 20,
          confidenceLevel: 0.78,
          basedOnDays: 8,
          minQuantity: 14,
          maxQuantity: 26,
        },
        {
          productId: '5',
          productName: 'Éclair au chocolat',
          predictedQuantity: 18,
          confidenceLevel: 0.75,
          basedOnDays: 6,
          minQuantity: 12,
          maxQuantity: 24,
        },
      ],
      expectedContext: {
        dayOfWeek: 2,
        dayName: 'Mardi',
        isWeekend: false,
        weatherForecast: 'cloudy',
        specialEvent: 'Marché de Noël',
      },
      totalPredictedQuantity: 178,
      totalPredictedRevenue: 347,
      overallConfidence: 0.82,
      generatedAt: '2025-12-23T08:00:00.000Z',
      cached: false,
      event: {
        id: 'evt-comp-1',
        name: 'Marché de Noël Capitole',
        date: '2025-12-24',
        type: 'market',
        location: 'Place du Capitole, Toulouse',
        expectedAffluence: 'high',
      },
    },
    'evt-comp-2': {
      _id: 'pred-evt-comp-2',
      userId: 'mock-user-id',
      date: '2025-12-24',
      eventId: 'evt-comp-2',
      eventName: 'Festival Ramonville',
      predictedProducts: [
        {
          productId: '1',
          productName: 'Croissant',
          predictedQuantity: 55,
          confidenceLevel: 0.9,
          basedOnDays: 15,
          minQuantity: 48,
          maxQuantity: 62,
        },
        {
          productId: '2',
          productName: 'Pain au chocolat',
          predictedQuantity: 40,
          confidenceLevel: 0.87,
          basedOnDays: 15,
          minQuantity: 34,
          maxQuantity: 46,
        },
        {
          productId: '3',
          productName: 'Baguette',
          predictedQuantity: 80,
          confidenceLevel: 0.85,
          basedOnDays: 12,
          minQuantity: 70,
          maxQuantity: 90,
        },
        {
          productId: '4',
          productName: 'Pain aux raisins',
          predictedQuantity: 25,
          confidenceLevel: 0.8,
          basedOnDays: 10,
          minQuantity: 18,
          maxQuantity: 32,
        },
        {
          productId: '5',
          productName: 'Éclair au chocolat',
          predictedQuantity: 22,
          confidenceLevel: 0.76,
          basedOnDays: 8,
          minQuantity: 16,
          maxQuantity: 28,
        },
      ],
      expectedContext: {
        dayOfWeek: 3,
        dayName: 'Mercredi',
        isWeekend: false,
        weatherForecast: 'sunny',
        specialEvent: 'Festival Ramonville',
      },
      totalPredictedQuantity: 222,
      totalPredictedRevenue: 428,
      overallConfidence: 0.84,
      generatedAt: '2025-12-29T08:00:00.000Z',
      cached: false,
      event: {
        id: 'evt-comp-2',
        name: 'Festival Ramonville',
        date: '2025-12-30',
        type: 'festival',
        location: 'Ramonville-Saint-Agne',
        expectedAffluence: 'high',
      },
    },
  },
};
